<template>
  <div>
    <div class="panel">
        <el-form ref="fieldForm" :model="form" label-width="120px">
             <el-row :gutter="5">
                 <el-col :span="24">
                     <el-form-item label="目标表单" prop="formName">
                          <!-- <el-select
                             v-model="form.formName"
                             clearable
                             filterable
                             placeholder="请选择"
                             style="width:100%;"
                             disabled
                         >
                             <el-option
                             v-for="item in orderStatusList"
                             :key="item.value"
                             :label="item.label"
                             :value="item.value"
                             ></el-option>
                         </el-select> -->
                         <el-input size="medium" v-model="form.formName" placeholder="输入" disabled></el-input>
                     </el-form-item>
                 </el-col>
                 <el-col :span="24">
                     <el-form-item label="编号前缀" prop="codePrefix">
                         <el-input size="medium" v-model="form.codePrefix" placeholder="输入"></el-input>
                     </el-form-item>
                 </el-col>
                 <el-col :span="24">
                    <el-form-item label="提交时间" prop="submitTime">
                      <el-radio-group v-model="form.submitTime" @change="dateChange">
                        <el-radio label="年">年</el-radio>
                        <el-radio label="年月">年月</el-radio>
                        <el-radio label="年月日">年月日</el-radio>
                      </el-radio-group>
                     </el-form-item>
                 </el-col>
                 <el-col :span="24">
                     <el-form-item label="流水号" prop="SerialNumber">
                        <el-input-number v-model="form.SerialNumber" controls-position="right" @change="handleChange" :min="1" :max="8" style="width: 90px;" size="small"></el-input-number>
                        <span>位</span>
                        <span style="margin-left: 20px;color: rgb(153, 153, 153);font-size: 12px;">例：{{such}}</span>
                     </el-form-item>
                 </el-col>
                 <el-col :span="24">
                     <el-form-item label="目标表单编号生成规则" prop="codeRule">
                         <el-input size="medium" v-model="form.codeRule" readonly></el-input>
                     </el-form-item>
                 </el-col>
                 <el-col :span="24">
                     <el-form-item label="编号预览" prop="name">
                         <el-input size="medium" v-model="form.preview" readonly></el-input>
                     </el-form-item>
                 </el-col>
             </el-row>
        </el-form>


    </div>
    <div class="panel-bottom">
         <el-button size="small" type="default"  @click="closeDialog">取消</el-button>
         <el-button size="small" type="primary"  @click="handleSave">保存</el-button>
     </div>
  </div>
</template>
<script>
export default {
 name:'addField',
 props:{
     fieldData:{
         type:Object,
         default:function(){
             return {};
         },
     },
     mode:{
       type:String,
       default:''
     }

 },
 watch:{
     fieldData:{
       handler:function(newVal,oldVal){
        if(newVal){
            this.form = JSON.parse(JSON.stringify(newVal));

        }
      },
      deep:true,
      immediate:true
     }
 },
 data(){
     return{
         form:{
         },
         such:'9',
         orderStatusList: [
          { label: "文本", value: "0" },
          { label: "数字", value: "1" },
          { label: "时间", value: "2"},
          {label: "附件", value: "3" },
          {label: "图片",value: "4"},
          {label: "单选框",value: "5"},
          {label: "复选框",value: "6"},],

     }
 },
 created(){
  this.dateChange()
  this.changeResult()
 },
 methods:{
     handleSave(){
         this.$refs["fieldForm"].validate((valid) => {

             if (valid) {

                 this.$emit('save',this.form);
             }
         })

     },

     closeDialog(){
        this.$emit('close');
     },
     dateChange(){
      var date = new Date()
      var year = date.getFullYear()
      var mounth =(date.getMonth() + 1) < 10 ? ('0' + (date.getMonth() + 1)) : (date.getMonth() + 1)
      var day = date.getDate() < 10 ? ('0' + date.getDate()): date.getDate()
      var res = ''
      switch (this.form.submitTime) {
        case '年':
          res = year
          break;
        case '年月':
          res = year + mounth
          break;
        case '年月日':
          res = year + mounth + day
          break;
        default:
          break;
        }
        this.res = res
        this.changeResult()
     },
     handleChange(){
      this.changeResult()
     },
     changeResult(){
      var suchStart = ''
      var suchEnd = ''
      var trueNum = ''
      this.such = ''
      var date = ''
      for(var i = 0 ;i<this.form.SerialNumber;i++){
        suchStart+='0'
        suchEnd+='9'
        this.such += '9'
        if(i!=(this.form.SerialNumber-1)){
          trueNum += '0'
        }else{
          trueNum += '1'
        }
      }
   
      
      this.form.codeRule = this.form.codePrefix  + '+' + this.form.submitTime + '+' + suchStart + '-' + suchEnd
      this.form.preview = this.form.codePrefix  + this.res + trueNum
     }


 }

}
</script>
<style scoped>
 .panel{
     overflow-y: auto;
     overflow-x: hidden;
 }

 .panel-bottom{
     width: 100%;
     height: 40px;
     line-height: 40px;
     padding-top: 20px;
     text-align: center;
 }
 .panel-bottom el-button{
     margin: 10px 0 0 10px;
 }


</style>



// WEBPACK FOOTER //
// src/views/customSetting/customRule/CreateLayout.vue